import axios from "axios";
import React, { useEffect, useState, useRef } from "react";
import { useLocation } from "react-router-dom";
import { UAParser } from "ua-parser-js";
import useFbc from "../../hooks/useFbc";
import useFbp from "../../hooks/useFbp";
import { getClientIp } from "../../libraries/ercLibrary";

export default function DetectFBCookie() {
  const location = useLocation();
  const userAgent = new UAParser().getUA();
  const fbp = useFbp();
  const fbc = useFbc();

  const isBeddoTestUser = localStorage.getItem("isBeddoTestUser") === "true";

  // SAVE IP IN STATE
  const [ip, setIp] = useState("");

  const latestRef = useRef({ ip: "", userAgent: "", fbp: "", fbc: "" });

  useEffect(() => {
    latestRef.current = { ip, userAgent, fbp, fbc };
  }, [ip, userAgent, fbp, fbc]);

  useEffect(() => {
    if (location.pathname.includes("admin-panel")) return;
    if (isBeddoTestUser) return;
    if (ip) return;

    (async () => {
      const ipStr = await getClientIp();
      setIp(ipStr);
    })();
  }, [ip, location.pathname, isBeddoTestUser]);

  // POST DATA TO SERVER IF ANY
  useEffect(() => {
    if (location.pathname.includes("admin-panel")) return;
    if (isBeddoTestUser) return;

    const currentPath = location.pathname;

    const timer = setTimeout(() => {
      const { ip, userAgent, fbp, fbc } = latestRef.current;

      const eventId = `pv_${Date.now()}_${Math.random().toString(36).slice(2)}`;

      window.fbq("track", "PageView", {}, { eventID: eventId });

      if (ip && userAgent) {
        axios
          .post("/api/facebookCapi/PageView", {
            country: "TR",
            userAgent,
            fbp: fbp || null,
            fbc: fbc || null,
            ip,
            location: currentPath,
            eventId,
          })
          .catch(() => {});
      }
    }, 800);

    return () => clearTimeout(timer);
  }, [location.pathname, isBeddoTestUser]);

  return <div></div>;
}
